import styles from "./Teams.module.css";
import ListItem from "../ListItem/ListItem";

const Teams = ({ teams }) => {
  return (
    <div className={styles.main}>
      {teams.map((team, index) => (
        <div className={styles.teamOuter} key={index}>
          <p>Team#{index + 1}</p>
          {team.map((person, i) => (
            <ul className={styles.teamList} key={i}>
              <ListItem>{person}</ListItem>
            </ul>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Teams;
